import { produce } from "immer";
import { Store } from "reducers/rootReducer";


/* STATE */
type State = {
  visible: boolean;
  collapse: boolean;  
}

const initialState: State = {
  visible: true,
  collapse: false,
}    

/* ACTIONS */
const SHOW_LEFT_MENU = "SHOW_LEFT_MENU";
const COLLAPSE_LEFT_MENU = "COLLAPSE_LEFT_MENU";
const REMOVE_LEFT_MENU = "REMOVE_LEFT_MENU";

type Action =
| { type: typeof SHOW_LEFT_MENU }
| { type: typeof COLLAPSE_LEFT_MENU }
| { type: typeof REMOVE_LEFT_MENU }

/* REDUCER */
export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case COLLAPSE_LEFT_MENU:
          if (state.collapse === true) {
            draft.collapse = false;
          } else {
            draft.collapse = true;
          }
          break;
      case REMOVE_LEFT_MENU:
            draft.visible = false;
          break;
      case SHOW_LEFT_MENU:
            draft.visible = true;
            break;
      default:
          break;
    }
  })
}

/* ACTION CREATORS */
export const removeLeftMenu = (): Action => ({
  type: REMOVE_LEFT_MENU,
});

export const showLeftMenu = (): Action => ({
  type: SHOW_LEFT_MENU,
});

export const collapseLeftMenu = (): Action => ({
  type: COLLAPSE_LEFT_MENU,
});

/* SELECTORS */
export const selectCollapse = (app: Store) => app.leftMenu.collapse;
export const selectVisible = (app: Store) => app.leftMenu.visible;
